import { useEffect, useState } from 'react';

export const useCountDownTimer = () => {
  const [seconds, setSeconds] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [complete, setComplete] = useState(false);

  const setCountDown = (minutes: number, seconds?: number) => {
    setComplete(false);
    setMinutes(minutes);
    setSeconds(seconds ?? 0);
  };

  const updateTimeRemaining = () => {
    if (!minutes && !seconds) {
      setComplete(true);
      return;
    }

    if (seconds === 0) {
      setMinutes((prev) => prev - 1);
      setSeconds(59);
      return;
    }

    setSeconds((prev) => prev - 1);
  };

  useEffect(() => {
    if(complete) {
      return;
    }

    const token = setInterval(updateTimeRemaining, 1000);

    return function cleanUp() {
      clearTimeout(token);
    };
  }, [minutes, seconds, complete]);

  return {
    setCountDown,
    seconds,
    minutes,
    complete,
  };
};